export const convertSnakeCaseToReadableString = (string: string) =>
  string.replace("_", " ");
